import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=8b4438a0&"
import script from "./Callback.vue?vue&type=script&lang=js&"
export * from "./Callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports